import { useForm } from 'react-hook-form';
import {
  dataToForm,
  EmploymentFormValues,
  formToBody,
  UpsertIncomeDTO,
} from './EmploymentForm.meta';
import { IncomeModel, IncomeType } from '../../api/useIncomeQuery';
import { useUpsertIncomeMutation } from '../../api/useUpsertIncomeMutation';
import { toast } from '../../../../CommonComponents/OPL/Toast/Toast';
import {
  ADD_INCOME_SUCCESS_MESSAGE,
  EDIT_INCOME_SUCCESS_MESSAGE,
  CLONE_INCOME_SUCCESS_MESSAGE,
  getShowAdvanced,
} from '../../Income.meta';
import { IncomeData } from '../../useIncome';

interface Params {
  clientId: string;
  income: (IncomeModel & { isClone?: boolean }) | null;
  data: IncomeData;
  onSuccess: () => void;
  readOnly?: boolean;
}

export const useEmploymentForm = ({ clientId, income, data, onSuccess, readOnly }: Params) => {
  const defaultValues = dataToForm(income, data);

  const formBag = useForm<EmploymentFormValues>({
    defaultValues,
    disabled: readOnly,
  });

  const mutationBag = useUpsertIncomeMutation({ clientId });

  const defaultShowAdvanced = !!income && getShowAdvanced(income);

  const onSubmit = formBag.handleSubmit(async (values: EmploymentFormValues) => {
    const body: UpsertIncomeDTO = {
      clientId,
      ...formToBody(values),
      id: (!income?.isClone && income?.Id) || null,
      incomeType: IncomeType.Salary,
    };

    try {
      await mutationBag.mutateAsync(body);

      toast.success(
        income?.Id
          ? income.isClone
            ? CLONE_INCOME_SUCCESS_MESSAGE
            : EDIT_INCOME_SUCCESS_MESSAGE
          : ADD_INCOME_SUCCESS_MESSAGE,
      );

      onSuccess();
    } catch (error) {
      console.error(error);
    }
  });

  const resetValues = () => {
    formBag.reset(dataToForm(income, data));
  };

  return {
    data: {
      formBag,
      mutationBag,
      defaultShowAdvanced,
    },
    actions: {
      onSubmit,
      resetValues,
    },
  };
};
